export default __webpack_public_path__ + "static/media/ic_swaziland.62b76e74.svg";